import { render, staticRenderFns } from "./review-similar.vue?vue&type=template&id=facff5da"
import script from "./review-similar.vue?vue&type=script&lang=ts"
export * from "./review-similar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports